var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "admin-config-rail",
      attrs: { "aria-label": _vm.trans("configuration.configuration") },
    },
    [
      _c("div", { staticClass: "admin-config-rail__head" }, [
        _c("span", { staticClass: "admin-config-rail__head-title" }, [
          _vm._v(_vm._s(_vm.trans("configuration.configuration"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "admin-config-rail__scroll" },
        [
          _c("span", { staticClass: "admin-config-rail__group" }, [
            _vm._v(_vm._s(_vm.trans("general.basic"))),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "basic",
              },
              attrs: { to: "/configuration/basic" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "building" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("general.basic"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: { "admin-config-rail__link--active": _vm.menu === "logo" },
              attrs: { to: "/configuration/logo" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "image" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("general.logo"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "system",
              },
              attrs: { to: "/configuration/system" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "settings" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("general.system"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "frontend",
              },
              attrs: { to: "/configuration/frontend" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "monitor" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(
                  _vm._s(_vm.trans("configuration.frontend_configuration"))
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "admin-config-rail__group" }, [
            _vm._v("Infrastructure"),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "server",
              },
              attrs: { to: "/configuration/server" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "database" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("configuration.server_configuration"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: { "admin-config-rail__link--active": _vm.menu === "mail" },
              attrs: { to: "/configuration/mail" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "mail" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("mail.mail"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "payment",
              },
              attrs: { to: "/configuration/payment" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "card" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(
                  _vm._s(_vm.trans("configuration.payment_configuration"))
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.getConfig("multilingual")
            ? _c(
                "router-link",
                {
                  staticClass: "admin-config-rail__link",
                  class: {
                    "admin-config-rail__link--active": _vm.menu === "locale",
                  },
                  attrs: { to: "/configuration/locale" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-config-rail__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "globe" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-config-rail__label" }, [
                    _vm._v(_vm._s(_vm.trans("locale.locale"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "admin-config-rail__group" }, [
            _vm._v("Access control"),
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: { "admin-config-rail__link--active": _vm.menu === "role" },
              attrs: { to: "/configuration/role" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "badge" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("role.role"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "permission",
              },
              attrs: { to: "/configuration/permission" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "key" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("permission.permission"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active":
                  _vm.menu === "authentication",
              },
              attrs: { to: "/configuration/authentication" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "shield" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("auth.authentication"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "admin-config-rail__group" }, [
            _vm._v("Operations"),
          ]),
          _vm._v(" "),
          _vm.getConfig("ip_filter")
            ? _c(
                "router-link",
                {
                  staticClass: "admin-config-rail__link",
                  class: {
                    "admin-config-rail__link--active": _vm.menu === "ip-filter",
                  },
                  attrs: { to: "/configuration/ip-filter" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "admin-config-rail__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "ethernet" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "admin-config-rail__label" }, [
                    _vm._v(_vm._s(_vm.trans("ip_filter.ip_filter"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "instance",
              },
              attrs: { to: "/configuration/instance" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "box" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("instance.instance"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "admin-config-rail__link",
              class: {
                "admin-config-rail__link--active": _vm.menu === "scheduled-job",
              },
              attrs: { to: "/configuration/scheduled-job" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "admin-config-rail__icon",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("admin-icon", { attrs: { name: "clock" } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "admin-config-rail__label" }, [
                _vm._v(_vm._s(_vm.trans("general.scheduled_job"))),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }